<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <AcknowledgementsOneFormFields></AcknowledgementsOneFormFields>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import AcknowledgementsOneFormFields from './acknowledgements/AcknowledgementsOneFormFields.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

const checkAll = computed({
    get() {
        return (
            account.compliance_profiles.esac.acknowledgements.currency_change_risk &&
            account.compliance_profiles.esac.acknowledgements.own_account &&
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering
        )
    },
    // setter
    set(newValue) {
        if (newValue) {
            account.compliance_profiles.esac.acknowledgements.currency_change_risk = true
            account.compliance_profiles.esac.acknowledgements.own_account = true
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering = true
        } else {
            account.compliance_profiles.esac.acknowledgements.currency_change_risk = false
            account.compliance_profiles.esac.acknowledgements.own_account = false
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering = false
        }
    },
})

const formOneFields: string[] = [
    'acknowledgements.currency_change_risk',
    'acknowledgements.own_account',
    'acknowledgements.anti_money_laundering',
]
const allAcknowledgementRules = getNaturalWidgetFormValidationRules('acknowledgements')

const acknowledgementsOneFormValidations = Object.keys(allAcknowledgementRules)
    .filter((key) => formOneFields.includes(key))
    .reduce((obj, key) => {
        obj[key] = allAcknowledgementRules[key]
        return obj
    }, {})

initializeNaturalWidgetForm(acknowledgementsOneFormValidations)
</script>
